import authAxios from '../authorization/axios';
import constants from '../constants';

export class CompaniesService {

  async getCompaniesByContactId(contactId: number) {
    const result = await authAxios.get(`${constants.api.getCompaniesByContact}`.replace(':id', contactId.toString()));
    return result.data?.data;
  }

}